import { render, staticRenderFns } from "./set_sign.vue?vue&type=template&id=266a3894"
import script from "./set_sign.vue?vue&type=script&lang=js"
export * from "./set_sign.vue?vue&type=script&lang=js"
import style0 from "./set_sign.vue?vue&type=style&index=0&id=266a3894&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JNproject\\qbyfdq-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('266a3894')) {
      api.createRecord('266a3894', component.options)
    } else {
      api.reload('266a3894', component.options)
    }
    module.hot.accept("./set_sign.vue?vue&type=template&id=266a3894", function () {
      api.rerender('266a3894', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/set_sign.vue"
export default component.exports